export default __webpack_public_path__ + "static/traefik-proxy-logo-7cdf43b21ebf91aff00fd60073a1fd9e.svg";